import { useEffect, useRef, useState } from "react";
import { Calendar } from "react-date-range";
import format from "date-fns/format";
import { fr } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

// French locale with week starting on Sunday
const frSunday = {
  ...fr,
  options: {
    ...fr.options,
    weekStartsOn: 0,
  },
};

const SundayCalendarComp = ({ onChange }) => {
  const [calendar, setCalendar] = useState("jj/mm/aaaa");
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const refOne = useRef(null);

  // Detect mobile and listen for viewport changes (e.g. rotation)
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 640px)");
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
    return () => {
      document.removeEventListener("keydown", hideOnEscape, true);
      document.removeEventListener("click", hideOnClickOutside, true);
    };
  }, []);

  const hideOnEscape = (e) => {
    if (e.key === "Escape") setOpen(false);
  };

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false);
    }
  };

  // Desktop: react-date-range returns a Date object directly
  const handleSelect = (date) => {
    setCalendar(format(date, "dd/MM/yyyy"));
    setOpen(false);
    onChange(date);
  };

  // Mobile: native <input type="date"> returns "YYYY-MM-DD" string
  const handleNativeChange = (e) => {
    const val = e.target.value;
    if (!val) return;
    // Parse as local date to avoid UTC midnight timezone shift
    const [year, month, day] = val.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    setCalendar(format(date, "dd/MM/yyyy"));
    onChange(date);
  };

  // ── Mobile: native date picker ──
  if (isMobile) {
    return (
      <div style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.5rem",
            padding: "0.65rem 0.75rem",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
        >
          <span
            className="material-symbols-outlined"
            style={{ fontSize: 18, color: "#00447f", display: "inline-block", lineHeight: 1, flexShrink: 0 }}
          >
            calendar_today
          </span>
          <input
            type="date"
            onChange={handleNativeChange}
            style={{
              border: "none",
              outline: "none",
              fontSize: "1rem",
              fontFamily: "Inter, sans-serif",
              color: "#181c23",
              backgroundColor: "transparent",
              width: "100%",
              cursor: "pointer",
            }}
          />
        </div>
      </div>
    );
  }

  // ── Desktop: custom calendar ──
  return (
    <div ref={refOne} style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          backgroundColor: "#ffffff",
          border: "none",
          borderRadius: "0.5rem",
          padding: "0.75rem 1rem",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          fontSize: "0.95rem",
          fontFamily: "Inter, sans-serif",
          cursor: "pointer",
          color: calendar === "jj/mm/aaaa" ? "#9ca3af" : "#181c23",
          outline: "none",
          minWidth: "10rem",
        }}
      >
        <span
          className="material-symbols-outlined"
          style={{ fontSize: 18, color: "#00447f", display: "inline-block", lineHeight: 1 }}
        >
          calendar_today
        </span>
        {calendar}
      </button>

      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 999 }}>
          <Calendar
            date={new Date()}
            onChange={handleSelect}
            locale={frSunday}
          />
        </div>
      )}
    </div>
  );
};

export default SundayCalendarComp;
